// บรอดแคสต์ strings, merged into the S3 translations at boot (i18n.js), like locales/messenger.js.
// Thai copy is verbatim from the Proship Messenger mockup (docs/mockups/messenger-in-proship/app.js).
// Labels the API sends (chipTh, blockTh, labelTh, groupsTh, ...) are shown as they come, not kept here.
// No literal braces in values: vue-i18n reads {x} as a parameter.
const th = {
  menu: "บรอดแคสต์",
  customers_title: "ลูกค้าที่เคยทักมา",
  people: "คน",
  back: "ย้อนกลับ",
  close: "ปิด",
  pages: {
    title: "ส่งจากเพจไหน?",
    search: "ค้นหาชื่อเพจ",
    select_all: "เลือกทุกเพจ",
    clear: "ล้าง",
    syncing_note: "เพจที่ยังอ่านแชทเก่าไม่เสร็จ จะส่งถึงเฉพาะลูกค้าที่เจอแล้ว",
    selected: "เลือก {n} เพจ",
    next: "ถัดไป",
    ready: "พร้อม",
    reconnect: "เชื่อมต่อใหม่",
  },
  customers: {
    from_pages: "จาก {n} เพจ",
    change: "เปลี่ยน",
    sync_title: "ดึงแชทย้อนหลัง 30 วัน",
    fresh: "อัปเดตล่าสุด {n} วิ ที่แล้ว",
    more_pages: "และอีก {n} เพจ",
    filter_tracked: "ส่งเลขพัสดุจากโปรชิปแล้ว",
    filter_ordered: "สั่งแล้ว",
    filter_interested: "สนใจแต่ยังไม่สั่ง",
    filter_one_message: "ทักมาข้อความเดียว",
    filter_all: "ทุกคน",
    sent_count: "ทัก {n} ครั้ง",
    hours_ago: "{n} ชม. ที่แล้ว",
    yesterday: "เมื่อวาน",
    days_ago: "{n} วันที่แล้ว",
    more: "ดูเพิ่ม",
    empty: "ยังไม่มีลูกค้าในกลุ่มนี้",
    open_chat: "เปิดแชทในเฟส",
  },
  progress: {
    queued: "อยู่ในคิว ลำดับที่ {pos}",
    queued_eta: "อยู่ในคิว ลำดับที่ {pos} · เริ่มในอีกราว {min} นาที",
    got_of: "{got} / ~{total} คน",
    got_of_eta: "{got} / ~{total} คน · อีกราว {min} นาที",
    got: "{got} คน",
    got_eta: "{got} คน · อีกราว {min} นาที",
  },
};

export default {
  th: { broadcast: th },
  en: { broadcast: th },
};

